export default __webpack_public_path__ + "static/media/dateSelect.0fcb6ea8.svg";